// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

const environmentFocus = {
  name: 'Focus',
  production: true,
  firebaseConfig: {
    apiKey: 'AIzaSyC0Dg93gi0jqx0Adh-ybQVI_UHZ25XR3iI',
    authDomain: 'focus-horse.firebaseapp.com',
    projectId: 'focus-horse',
    storageBucket: 'focus-horse.appspot.com',
    databaseUrl: 'https://focus-horse-default-rtdb.europe-west1.firebasedatabase.app',
    messagingSenderId: '336454300258',
    appId: '1:336454300258:web:ea30e1b3fcb2f4f02d973b',
    measurementId: 'G-Z93DV0PPWP'
  }
};

export const environment = environmentFocus;

/*
 * In development mode, to ignore zone related error stack frames such as
 * `zone.run`, `zoneDelegate.invokeTask` for easier debugging, you can
 * import the following file, but please comment it out in production mode
 * because it will have performance impact when throw error
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
